import { getCookie } from '../cookie.js'
// 主导航
export const mainnav = [{
  url: 'http://xiaoxue.xdf.cn/xinban',
  title: '小学辅导'
},
{
  url: 'http://zhongxue.xdf.cn/xinban',
  title: '中学辅导'
},
{
  url: 'http://daxue.xdf.cn/xinban',
  title: '大学辅导'
},
{
  url: 'http://yingyu.xdf.cn/xinban',
  title: '英语辅导'
},
{
  url: 'http://goabroad.xdf.cn/xinban',
  title: '出国留学'
},
{
  url: `http://xyz.xdf.cn/`,
  title: '小语种'
},
// {
//   url: `http://mhmusic.xdf.cn/`,
//   title: '音乐动漫'
// },
// {
//   url: `http://souke.xdf.cn/Teacher/${getCookie('soukecityid')}.html`,
//   title: '教师查询'
// },
]
window.getCookie=getCookie;



// WEBPACK FOOTER //
// ./src/api/js/home/mainnav.js